import { useQuery } from '@tanstack/react-query';
import { getTransaction } from '../api/transaction';

export const useGetTransaction = ({ enabled = true, ...params }) => {
  return useQuery({
    queryKey: ['transactionList', params, enabled],
    queryFn: ({ signal }) => getTransaction(params, signal),
    enabled: enabled,
  });
};
